import { Input } from 'shared/ui/controls/Input'
import { Select } from 'shared/ui/controls/Select'
import { FormSubmitter } from 'shared/ui/common/FormSubmitter'
import {
  FormInfoItem,
  FormInfoFrame,
  FormInfoFramesList,
} from 'shared/ui/common/FormInfoFrame'
import { poolAssetOptions } from 'modules/pools/constants/poolAssets'
import { BorrowLockCode } from 'modules/pools/constants/lockCodes'
import { WarningCard } from 'shared/ui/common/WarningCard'

import s from './FormBorrowBlocked.module.scss'

const borrowOptions = [poolAssetOptions.USDC]
const collateralOptions = [poolAssetOptions.WETH]

type Props = {
  lockCode?: BorrowLockCode
}

export function FormBorrowBlocked({ lockCode }: Props) {
  const borrowedAsset = borrowOptions[0].value
  const collateralAsset = collateralOptions[0].value

  return (
    <div>
      <WarningCard
        title={
          <>
            V1 will be shut down soon. Please use{' '}
            <a
              href="https://roci.fi/app"
              target="_blank"
              className={s.v2Link}
              rel="noreferrer"
            >
              RociFi V2
            </a>
            .
          </>
        }
      />
      <Select
        name="borrowedAsset"
        placeholder="Borrowed asset"
        value={borrowedAsset}
        options={borrowOptions}
        readOnly
      />
      <Input
        name="amount"
        concat="bottom"
        placeholder="Amount"
        onlyNumber
        readOnly
      />
      <Select
        name="term"
        concat="top"
        placeholder="Term"
        options={[]}
        readOnly
      />
      <Select
        name="collateralAsset"
        placeholder="Collateral asset"
        value={collateralAsset}
        options={collateralOptions}
        readOnly
      />
      <FormInfoFramesList>
        <FormInfoFrame>
          <FormInfoItem label="APR" value={''} />
          <FormInfoItem
            label="Amount to be repaid"
            value={''}
            sign={borrowedAsset}
          />
        </FormInfoFrame>
        <FormInfoFrame>
          <FormInfoItem label="LTV" value={''} />
          <FormInfoItem
            label="Collateral to be added"
            value={''}
            sign={collateralAsset}
          />
        </FormInfoFrame>
        <FormInfoFrame>
          <FormInfoItem label="Liquidation Threshold" value={''} />
          <FormInfoItem label="Liquidation Price" value={''} sign="USD" />
        </FormInfoFrame>
      </FormInfoFramesList>
      <FormSubmitter isDisabled firstStepText="Borrow" />
    </div>
  )
}
